export default  {
  name: 'blog',
  props: [],
  mounted() {
    
  },
  data() {
    return {
      posts: [],
      post: [],
      flag: []
    }
  },
  methods: {
    getPostRow(nrow) {
      return this.posts.filter((e, i) => i >= (nrow-1)*3 && i < nrow*3);
    },
    getPost(){
      var route = this.$route
      for( var i=0; i<this.posts.length; i++ ) 
        if(this.posts[i].linkid == route.params.id)
          this.post = this.posts[i];      
    },
    backHome() {
      console.log("TUT")
      this.$localStorage.set('fromPost', true);
      this.$router.push('/');
    }
  },
  computed: {
  },
  created() {
    this.posts = require('./../../data/posts.js').map((e, i) => { e.id = i; return e });    
    this.flag = require('./../../data/flag.js');
    this.getPost();
  }
}



// WEBPACK FOOTER //
// ./src/components/Blog/Blog.component.js